export const LIST_PAGE_INITIAL_ITEM_LIMIT = 10;

export const LIST_PAGE_SCROLL_LOAD_LIMIT = 5;
export const DISTRIBUTION_DETAILS_LOCATION_LIST_LIMIT = 500;
